import { gql } from "@apollo/client";

export const GET_PROVIDER_CONTENT = gql`
  query Items {
    ProviderContentMany(perPage: 1000, filters:  { status: CURRENT }) {
      items {
        _id
        companyId
        title
        provider
        version
        sourceId
        previewUrl
        projectTitle
        updatedAt
      }
    }
  }
`
